import { memo, useRef } from "react";
import { motion } from "framer-motion";
import FocusTrap from "focus-trap-react";

import { useOutsideClick } from "~/hooks/useOutsideClick";

import { DIALOG_MODAL_ANIMATION_DURATION, useDialogModal } from "./DialogModal";

import type { ReactNode } from "react";

export interface DialogModalPanelProps {
  children?: ReactNode;
}

export const DialogModalPanel = memo(function DialogModalPanel({
  children,
}: DialogModalPanelProps) {
  const ref = useRef<HTMLDivElement>(null);

  const { isOpen, requestClose } = useDialogModal();

  useOutsideClick(ref, () => {
    requestClose?.();
  });

  return (
    <FocusTrap
      active={Boolean(isOpen && children)}
      focusTrapOptions={{
        fallbackFocus() {
          return ref.current!;
        },
      }}
    >
      <motion.div
        ref={ref}
        tabIndex={-1}
        className="DialogModalPanel"
        initial={{ opacity: 0, transform: "scale(0.95)" }}
        animate={{ opacity: 1, transform: "scale(1)" }}
        exit={{ opacity: 0, transform: "scale(0.95)" }}
        transition={{
          duration: DIALOG_MODAL_ANIMATION_DURATION,
        }}
      >
        {children}
      </motion.div>
    </FocusTrap>
  );
});
